// extracted by mini-css-extract-plugin
module.exports = {"box":"index-module__box___7tzav","title":"index-module__title___1Z-gE"};